import React, { Component } from 'react'
import Axios from 'axios'
import { toast, ToastContainer } from 'react-toastify'
import Loader from '../Loader'
import ProgressBar from '../ProgressBar/ProgressBar'
import { Urls } from '../../Urls'
import { constants } from '../../constants'
import { logActivity } from '../Utilities'
var raw_suggestion = []
var raw_manual = []
var raw_input = []
var current_row = 0
class SpellCorrection extends Component {
    constructor(props) {
        super(props)

        this.state = {
            suggestions: [],
            search: [],
            loader: false,
            locAuto: []
        }
    }

    componentDidMount() {
        // logActivity([
        //     {
        //         'screen': 'Spell Correction Location',
        //         'module': 'Location Cleaning',
        //         'user_activity': 'page viewed',
        //         'timestamp': new Date().toISOString()
        //     }
        // ])
        document.getElementById("header").style.opacity = "0.5"
        document.title = "DC | Spell Correction"
        const body = {
            "dataset_id": localStorage.getItem("dataset_id"),
            "key": "spell"
        }
        this.setState({
            loader: true
        }, () => {
            Axios.post(Urls.location.fetch, body)
                .then(response => {
                    console.log(response.data)
                    this.setState({
                        suggestions: response.data.data,
                        search: response.data.search,
                        loader: false
                    }, () => { if (this.state.suggestions.length === 0) { this.props.history.push({ pathname: "/manualLocation" }) } })
                    document.getElementById("header").style.opacity = "1"
                    var i;
                    for (i = 0; i < this.state.suggestions.length; i++) {
                        raw_suggestion.push({ "suggestion": this.state.suggestions[i].Suggestion[0] })
                        raw_manual.push({ "manual": "" })
                    }
                })
                .catch(error => {
                    this.setState({ loader: false })
                    console.log(error)
                    toast.error("Error while processing your reuest")
                })
        })
    }

    // select handler
    selectHandler = (event) => {
        if (event.target.value === "Other") {
            document.getElementById(event.target.name).disabled = false
            document.getElementById(event.target.name).style.border = "1px solid royalblue"
            raw_suggestion[event.target.name] = { "suggestion": "Other" }
        }
        else if (event.target.value === 'same_as_client_data') {
            document.getElementById(event.target.name).disabled = false
            document.getElementById(event.target.name).style.border = "1px solid royalblue"
            raw_suggestion[event.target.name] = { "suggestion": "Other" }
            var client_data = `${this.state.suggestions[event.target.name]['Raw Location']},,${this.state.suggestions[event.target.name]['Raw State']}`
            document.getElementById(event.target.name).value = client_data
            raw_manual[event.target.name] = { 'manual': client_data }
        }
        else {
            document.getElementById(event.target.name).disabled = true
            document.getElementById(event.target.name).style.border = "none"
            raw_suggestion[event.target.name] = { "suggestion": event.target.value }
            raw_manual[event.target.name] = { "manual": "" }
        }
    }

    // manaul handler
    manualChangeHandler = (event) => {
        current_row = parseInt(event.target.id)
        if (event.target.value !== "" && ((event.target.value.length >= 3))) {
            Axios.get(`${Urls.autocomplete}?country=INDIA&limit=10&suggest=${event.target.value}&searchFields=locations`)
                .then(res => {
                    this.setState({
                        locAuto: res.data.value
                    })
                })
                .catch(error => {
                    console.log(error)
                })
        }
        raw_manual[event.target.id] = { "manual": event.target.value }
    }


    // SUbmit  
    submitHandler = (event) => {
        event.preventDefault()
        var patternStatus = true
        var i = 0
        for (i = 0; i < raw_manual.length; i++) {
            if(document.getElementById(i) && document.getElementById(i).disabled && document.getElementById(i).disabled === false) {
                if (!new RegExp(constants.regex_patterns.emptyString).test(raw_manual[i]['manual'])) {
                    if (!new RegExp(constants.regex_patterns.location).test(raw_manual[i]['manual'])) {
                        document.getElementById(i).style.border = '1px solid red'
                        patternStatus = false
                    }
                    else {
                        document.getElementById(i).style.border = 'none'
                        patternStatus = true
                    }
                }
            }
        }

        if (patternStatus) {
            // logActivity([
            //     {
            //         'screen': 'Spell Correction Location',
            //         'module': 'Location Cleaning',
            //         'user_activity': 'data submission',
            //         'timestamp': new Date().toISOString()
            //     }
            // ])
            document.getElementById("header").style.opacity = "0.5"
            event.preventDefault()
            raw_input = []
            raw_input.push(raw_suggestion)
            raw_input.push(raw_manual)
            var body = {
                "dataset_id": localStorage.getItem("dataset_id"),
                "key": "spell",
                "input": raw_input
            }
            console.log('==========================')
            console.log(raw_input)
            console.log('==========================')
            this.setState({
                loader: true
            }, () => {
                Axios.post(Urls.location.dump, body)
                    .then(response => {
                        console.log(response.data)
                        this.setState({ loader: false })
                        sessionStorage.setItem('prevScreen', this.props.history.location.pathname)
                        this.props.history.push({
                            pathname: "/manualLocation"
                        })
                    })
                    .catch(error => {
                        console.log(error)
                        this.setState({ loader: false })
                        toast.error("Error while dumping data")
                    })
            })
        }
        else {
            alert('Please enter correct location, Eg. City, District(optional), State')
        }

    }

    // navigation toggles
    goBack = () => {
        this.props.history.push({
            pathname: "/multiLocation"
        })
    }


    render() {
        const locations = this.state.suggestions
        const searchItems = this.state.locAuto
        return (
            <div id="header">
                <ToastContainer />
                <Loader isLoading={this.state.loader} />
                <div className="container">
                    <div style={{ "margin-bottom": "5%" }}>
                        <div className="row" align="center">
                            <div className="col-1">
                                <button onClick={this.goBack}><i className="navButtonsCircleLeft fas fa-arrow-circle-left"></i></button>
                            </div>
                            <div className="col-10">
                                <table border="1" width="50%" id="dc_table">
                                    <thead>
                                        <tr>
                                            <th>Sr. No.</th>
                                            <th>
                                                Raw Location
                                    </th>
                                            <th>
                                                Raw State
                                    </th>
                                            <th>
                                                Suggestion
                                    </th>
                                            <th>
                                                User Input
                                    </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            locations.map((location, i) =>
                                                (location.Suggestion.length === 0) ? (
                                                    <tr style={{ "backgroundColor": "#EEEEEE" }}>
                                                        <td> {i + 1} </td>
                                                        <td> {location['Raw Location']} </td>
                                                        <td> {location['Raw State']} </td>
                                                        <td>
                                                            <select name={i} onChange={this.selectHandler} >
                                                                {
                                                                    location.Suggestion.map(s => <option value={s}> {s} </option>)
                                                                }
                                                                <option value="same_as_client_data">Same as Client Data</option>
                                                                <option value="Other">Other</option>
                                                            </select>
                                                        </td>
                                                        <td>
                                                            <input className="form-control" list="auto" id={i} onChange={this.manualChangeHandler} placeholder="City, District, State" disabled />
                                                            {
                                                                (current_row === i) ? (
                                                                    <datalist id="auto">
                                                                        {
                                                                            (searchItems.length === 0 || searchItems === undefined) ? (<option>No location found!</option>) : (
                                                                                searchItems.map(item => <option value={`${item.location.location}, ${item.location.district}, ${item.location.state}, ${item.location.lat}, ${item.location.lon}`}> {`${item.location.location}, ${item.location.district}, ${item.location.state}`} </option>
                                                                                ))
                                                                        }
                                                                    </datalist>
                                                                ) : (null)
                                                            }
                                                        </td>
                                                    </tr>
                                                ) : (
                                                        <tr>
                                                            <td> {i + 1} </td>
                                                            <td> {location['Raw Location']} </td>
                                                            <td> {location['Raw State']} </td>
                                                            <td>
                                                                <select name={i} onChange={this.selectHandler} >
                                                                    {
                                                                        location.Suggestion.map(s => <option value={s}> {s} </option>)
                                                                    }
                                                                    <option value="same_as_client_data">Same as Client Data</option>
                                                                    <option value="Other">Other</option>
                                                                </select>
                                                            </td>
                                                            <td>
                                                                <input className="form-control" list="auto" id={i} onChange={this.manualChangeHandler} placeholder="City, District, State" disabled />
                                                                {
                                                                    (current_row === i) ? (
                                                                        <datalist id="auto">
                                                                            {
                                                                                (searchItems.length === 0 || searchItems === undefined) ? (<option>No location found!</option>) : (
                                                                                    searchItems.map(item => <option value={`${item.location.location}, ${item.location.district}, ${item.location.state}, ${item.location.lat}, ${item.location.lon}`}> {`${item.location.location}, ${item.location.district}, ${item.location.state}`} </option>
                                                                                    ))
                                                                            }
                                                                        </datalist>
                                                                    ) : (null)
                                                                }
                                                            </td>
                                                        </tr>
                                                    )
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <div className="col-1 navButtonsCircleRight">
                                <button onClick={this.submitHandler} title="Submit" ><i className=" fas fa-arrow-circle-right"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer_div">
                    <ProgressBar progress="50%" />
                </div>
            </div >
        )
    }
}

export default SpellCorrection
